import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirectoryMitreAdr = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 28,
	viewBox: "0 0 34 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M31.7863 5.41283H17.3622L12.6493 0.904799C12.5893 0.848661 12.5104 0.817111 12.4283 0.816406H2.21488C1.50372 0.816406 0.929169 1.39096 0.929169 2.10212V25.8878C0.929169 26.599 1.50372 27.1735 2.21488 27.1735H31.7863C32.4975 27.1735 33.072 26.599 33.072 25.8878V6.69855C33.072 5.98739 32.4975 5.41283 31.7863 5.41283ZM30.1792 24.2807H3.82203V3.70926H11.3957L16.201 8.30569H30.1792V24.2807Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgDirectoryMitreAdr);
export { ForwardRef as ReactComponent };
